import * as React from 'react';
import { useEffect, useMemo } from 'react';
import c from 'classnames';

import { LinkField } from '@uncinc/react-drupal-core/types';
import { WysiwygField, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import LinkListItem from './Item';
import Slider from '../../Slider';
import ButtonWrapper from '../../ButtonWrapper';
import { SCREEN_TABLET } from '../../../config/constants';

import './style.scss';

interface LinkListSubComponents {
  Item: typeof LinkListItem;
}

interface LinkListProps {
  isHomepage?: boolean;
  title?: string;
  body?: string;
  buttons?: LinkField[];
}

const LinkList: React.FC<LinkListProps> & LinkListSubComponents = (props) => {
  const {
    children,
    title,
    body,
    buttons,
  } = props;

  const renderedButtons = useMemo(() => buttons?.map((button) => (
    <ButtonWrapper
      href={button.uri}
    >
      {button.title}
    </ButtonWrapper>
  )), [buttons]);
  const { width } = useWindowDimensions();
  const isMobile = useMemo(() => width < SCREEN_TABLET, [width]);

  const childrenAmount = (children as React.ReactChild[]).length;
  const sliderClasses = c('LinkListNormal__sliderwrapper', `LinkListNormal-${childrenAmount}`);
  const gridClasses = c('LinkListNormal__gridwrapper', `LinkListNormal-${childrenAmount}`);

  return (
    <div className="LinkListNormal">

      <div className="Container">
        <div className="row">
          <div className="col-12 col-md-9 col-lg-8">
            <div className="LinkListNormal__content">
              <div className="LinkListNormal__title">
                <h2>
                  {title}
                </h2>
              </div>
              <div className="LinkListNormal__body">
                <WysiwygField
                  property="schema:text"
                  className="text--large"
                  html={body}
                />
              </div>
              <div className="LinkListNormal__buttons">
                {renderedButtons}
              </div>
            </div>
          </div>
        </div>
      </div>
      { (isMobile && childrenAmount >= 3) ? (
        <div className={sliderClasses}>
          <Slider>
            {children}
          </Slider>
        </div>
      ) : (
        <div className={gridClasses}>
          {children}
        </div>
      )}
    </div>
  );
};

LinkList.Item = LinkListItem;

export default LinkList;
